<template>
	<fieldset class="rating-input">
		<legend
			v-if="legend"
			v-html="legend"
		/>
		<div
			class="rating-input__wrapper"
			@mouseenter="onMouseEnter"
			@mouseleave="onMouseLeave"
		>
			<label
				class="rating-input__label"
				v-for="i in max"
				:key="`rating-input-${i}`"
				@mouseover="onHover(i)"
			>
				<input
					class="rating-input__input"
					type="radio"
					:id="`${uniqueId}-${i}`"
					:name="name"
					:required="required"
					:value="i"
					@change="onChange(i)"
					:checked="i === value"
					:disabled="disabled"
				>
				<SVGStarFilled
					class="rating-input__icon"
					:class="{
						'rating-input__icon--active': mouseOver ? hover >= i : value >= i,
					}"
				/>
			</label>
		</div>
	</fieldset>
</template>

<script>
import {isIos, isAndroid} from '@/utils/features';

export default {
	props: {
		max: {
			default: 5
		},
		legend: String,
		name: String,
		required: Boolean,
		disabled: Boolean,
		value: Number | String,
	},
	data() {
		return {
			uniqueId: `${this.name}-${(Date.now().toString(36) + Math.random().toString(36).substring(2, 7))}`,
			mouseOver: false,
			hover: null,
		}
	},
	methods: {
		onMouseEnter() {
			if (isIos || isAndroid) {
				return;
			}
			this.mouseOver = true;
		},
		onMouseLeave() {
			if (isIos || isAndroid) {
				return;
			}
			this.mouseOver = false;
			this.hover = null;
		},
		onHover(index) {
			if (isIos || isAndroid) {
				return;
			}
			this.hover = index;
		},
		onChange(value) {
			this.$emit('input', value);
		}
	}
}
</script>

<style>

</style>
